export default __webpack_public_path__ + "static/media/Inter-italic.var.e2e12d2e.woff2";